"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pager = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
const Icon_1 = require("../../Icon");
require("./index.scss");
const className = 'pager';
const Pager = (props) => {
    const { total, pagination, setPage, modificators, } = props;
    const pagesTotal = pagination.pageSize ? Math.ceil(total / pagination.pageSize) : 1;
    const currentPage = pagination.page + 1;
    const firstPage = 1;
    const lastPage = pagesTotal;
    const range = (from, to, step = 1) => {
        const result = [];
        let i = from;
        while (i <= to) {
            result.push(i);
            i += step;
        }
        return result;
    };
    const getPages = () => {
        const pageNeighbours = 1;
        /**
         * totalNumbers: the total page numbers to show on the control
         * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
         */
        const totalNumbers = (pageNeighbours * 2) + 3;
        const totalBlocks = totalNumbers + 2;
        if (pagesTotal > totalBlocks) {
            const startPage = Math.max(2, currentPage - pageNeighbours);
            const endPage = Math.min(pagesTotal - 1, currentPage + pageNeighbours);
            let pages = range(startPage, endPage);
            /**
             * hasLeftSpill: has hidden pages to the left
             * hasRightSpill: has hidden pages to the right
             * spillOffset: number of hidden pages either to the left or to the right
             */
            const hasLeftSpill = startPage > 2;
            const hasRightSpill = (pagesTotal - endPage) > 1;
            const spillOffset = totalNumbers - (pages.length + 1);
            switch (true) {
                // handle: (1) < {5 6} [7] {8 9} (10)
                case (hasLeftSpill && !hasRightSpill): {
                    const extraPages = range(startPage - spillOffset, startPage - 1);
                    pages = ['LEFT_PAGE', ...extraPages, ...pages];
                    break;
                }
                // handle: (1) {2 3} [4] {5 6} > (10)
                case (!hasLeftSpill && hasRightSpill): {
                    const extraPages = range(endPage + 1, endPage + spillOffset);
                    pages = [...pages, ...extraPages, 'RIGHT_PAGE'];
                    break;
                }
                // handle: (1) < {4 5} [6] {7 8} > (10)
                case (hasLeftSpill && hasRightSpill):
                default: {
                    pages = ['LEFT_PAGE', ...pages, 'RIGHT_PAGE'];
                    break;
                }
            }
            return [1, ...pages, pagesTotal];
        }
        return range(1, pagesTotal);
    };
    const handlePageChange = (newPage) => {
        const newPageIndex = newPage - 1;
        if (newPageIndex !== pagination.page && newPageIndex >= 0 && newPageIndex < pagesTotal) {
            setPage(newPageIndex);
        }
    };
    if (!total || pagesTotal === 1)
        return null;
    const pages = getPages();
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__prev` },
            react_1.default.createElement("button", { onClick: () => handlePageChange(currentPage - 1), ...currentPage === firstPage ? { disabled: true } : {} },
                react_1.default.createElement(Icon_1.Icon, { name: 'arrow-left' }))),
        react_1.default.createElement("div", { className: `${className}__numbers` }, pages.map((page, index) => {
            if (page === 'LEFT_PAGE') {
                return (react_1.default.createElement("button", { key: index, onClick: () => handlePageChange(currentPage - 1) }, "..."));
            }
            if (page === 'RIGHT_PAGE') {
                return (react_1.default.createElement("button", { key: index, onClick: () => handlePageChange(currentPage + 1) }, "..."));
            }
            return (react_1.default.createElement("button", { key: index, className: `${className}__${page === currentPage ? 'active' : ''}`, onClick: () => handlePageChange(page) }, page));
        })),
        react_1.default.createElement("div", { className: `${className}__next` },
            react_1.default.createElement("button", { onClick: () => handlePageChange(currentPage + 1), ...currentPage === lastPage ? { disabled: true } : {} },
                react_1.default.createElement(Icon_1.Icon, { name: 'arrow-right' })))));
};
exports.Pager = Pager;
//# sourceMappingURL=index.js.map